let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aGbvb")).then(() => parcelRequire('bsCeh'));